import { Component, RefObject } from "react";

import { EditProject } from "@app/projects/network-assessment/EditProject";
import { FlyoutLink } from "@app/shared/Flyouts";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

interface EditProjectOptionsLinkProps {
  containerId: string;
  disabled: boolean;
  projectId: number;
  /** Force updateState() call */
  forceUpdateProject?: () => Promise<void>;
  onUpdateProjectOptions?: () => Promise<void>;
  setProjectIsReadOnly?: (projectIds: number[]) => void;
  triggerElementOverride?: RefObject<HTMLButtonElement>;
}

interface EditProjectOptionsLinkState {
  projectOptionsDirty: boolean;
  triggerClose: () => void;
}

class EditProjectOptionsLink extends Component<EditProjectOptionsLinkProps, EditProjectOptionsLinkState> {

  constructor(props: EditProjectOptionsLinkProps) {
    super(props);

    this.state = {
      projectOptionsDirty: false,
      triggerClose: null,
    };
  }

  public render() {
    return (
      <FlyoutLink
        classNames="action-menu-item col-12 fw-normal"
        content={{
          body: (() => this.renderEditContent())(),
          title: "Project Options",
        }}
        modalContent={{
          body: "You will lose unsaved changes. Continue with closing the sidebar?",
          cancelButtonText: "Cancel",
          confirmButtonText: "Continue",
          title: "Warning",
        }}
        size="80"
        testId="edit-project-options-link__flyout-link"
        warnOnClose={this.state.projectOptionsDirty}
        onClose={this.handleExited}
        triggerElementOverride={this.props.triggerElementOverride}
      >
        <span className="project-action-button"><QesIcon iconName={QesIcons.PencilV1} isDecorative />Project Options</span>
      </FlyoutLink>
    );
  }

  private renderEditContent() {
    return (
      <EditProject
        sidePanelId={this.props.containerId}
        disabled={this.props.disabled}
        onChange={this.handleProjectOptionsChange}
        projectId={this.props.projectId}
        onRunProjectSuccess={this.handleRunProjectSuccess}
        onSubmitSuccess={this.handleSubmitSuccess}
      />
    );
  }

  private handleSubmitSuccess = async () => {
    if (this.state.projectOptionsDirty) {
      await this.props.onUpdateProjectOptions?.();
    }
  }

  private handleRunProjectSuccess = async () => {
    this.props.setProjectIsReadOnly?.([this.props.projectId]);
  }

  private handleProjectOptionsChange = (projectOptionsDirty: boolean) => {
    if (this.state.projectOptionsDirty !== projectOptionsDirty) {
      this.setState({ projectOptionsDirty });
    }
  }

  private handleExited = async () => {
    if (this.props.forceUpdateProject) {
      await this.props.forceUpdateProject();
    }
    this.setState({
      projectOptionsDirty: false,
    })
  }

}

export { EditProjectOptionsLink };
